import type { ReactNode } from "react";

export function JetsServiceIcon(): ReactNode {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Service</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3331 3.74959C18.3321 3.22709 18.014 2.89628 17.5936 3.02958C17.329 3.11325 14.2135 5.20128 14.5774 12.6942C14.6367 13.4717 14.9744 13.9961 15.5533 14.396C16.1215 14.7881 16.2713 15.2824 16.2159 15.9421C16.0855 17.5008 15.996 18.1157 15.9084 19.6783C15.8646 20.4664 16.4455 21.0395 17.2064 20.9977C17.8641 20.9617 18.3321 20.4246 18.3331 19.6764C18.337 16.8236 18.337 5.44647 18.3331 3.74959Z"
        stroke="#00AB4E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.683 3.37451C11.7482 4.83496 11.8192 6.29444 11.8776 7.75489C11.9156 8.70063 11.5916 9.51405 10.8832 10.1417C9.91412 10.9989 9.67574 12.0546 9.8071 13.3068C10.0484 15.6167 10.2255 16.9866 10.3899 19.3033C10.4561 20.2335 9.62028 21.0002 8.77281 21.0002C7.92437 21.0002 7.08857 20.2335 7.15474 19.3033C7.32015 16.9866 7.49626 15.6167 7.73756 13.3068C7.86891 12.0546 7.63053 10.9989 6.66143 10.1417C5.9531 9.51405 5.6291 8.70063 5.66704 7.75489C5.72542 6.29444 5.79645 4.83496 5.86164 3.37451"
        stroke="#00AB4E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.76758 6.91598L8.77731 3.45117"
        stroke="#00AB4E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
